/* eslint-disable @typescript-eslint/ban-ts-comment */
/**
 * 基于arco 2.42.0 版本的form改造的
 * 1. 布局 ✅
 *    新属性新增分栏能力 columnsNum, 默认为1 最大为 4
 * 2. 尺寸样式覆盖 ✅
 *    类型修改size属性，无新属性新增 目前只支持 default | large
 * 3. required 样式改造 ✅
 *    默认处理 required 为 true，
 *    对于非required的label增加(optional)
 * 4. 校验之后的信息逻辑 ✅
 * 5. 自定义表单校验逻辑 ✅
 * 6. label 的改造 ✅
 *    labelAlign 默认改为left
 * 7. form-item 范围内支持背景色的设置 通过style ,wrapperCol.style 和 labelCol.style ✅
 */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
import './style/index.less';
import { Form as ArcoForm } from '@arco-design/web-react';
import Form from './form';
import FormItem from './form-item';
import FormControl from './form-item/control';
import FormProvider from './form-provider';
import useForm from './useForm';
import useWatch from './hooks/useWatch';
import useFormContext from './hooks/useContext';
import FormList from './form-list';
import useFormState from './hooks/useState';
import { SearchAndFilter } from './search-and-filter';
/**
 * 保留 ArcoSelect 的引入不被树摇，让组件arco样式的按需加载功能可用。
 */
(function (_o) { })(ArcoForm);
export * from './interface';
var FormComp = Form;
FormComp.Provider = FormProvider;
FormComp.Item = FormItem;
FormComp.List = FormList;
FormComp.Control = FormControl;
FormComp.SearchAndFilter = SearchAndFilter;
FormComp.useForm = useForm;
FormComp.useFormContext = useFormContext;
FormComp.useWatch = useWatch;
FormComp.useFormState = useFormState;
export default FormComp;
